import { render, staticRenderFns } from "./TeamTargetsTable.vue?vue&type=template&id=89d82f54"
import script from "./TeamTargetsTable.vue?vue&type=script&lang=js"
export * from "./TeamTargetsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports